module.exports = __webpack_public_path__ + "img/pingshen-banner.361b3ee2.png";